import AXIOS_API from "../helpers/axios";
import { TrackingLinkDetailsDto, TrackingLinkDto, TrackingLinkPublicDetailsDto } from "../helpers/types";

class TrackingLinksService {
  public async createTrackingLinks(payload: { title: string }): Promise<any> {
    try {
      const res = await AXIOS_API.post("/track-links", payload, { withCredentials: true });
      const body = res?.data;

      return body?.data ?? body;
    } catch (error) {
      console.error("Error creating tracking link:", error);
      throw error;
    }
  }

  public async getTrackingLinks(params: { status: string }): Promise<TrackingLinkDto[]> {
    const { status } = params;
    const isActive = encodeURIComponent(status) === "active";

    const url = `/track-links?isActive=${isActive}`;
    const res = await AXIOS_API.get(url, { withCredentials: true });
    const body = res?.data;
    const payload = body?.data || body;
    return payload?.data || payload;
  }

  public async getTrackingLinkDetails(trackLinkId: string): Promise<TrackingLinkDetailsDto> {
    try {
      const res = await AXIOS_API.get(`/track-links/details`, {
        withCredentials: true,
        params: {
          token: trackLinkId,
        },
      });

      const body = res?.data;
      return body?.data ?? body;
    } catch (error) {
      console.error("Error getting tracking link details:", error);
      throw error;
    }
  }

  public async getPublicTrackingLinkDetails(trackLinkId: string): Promise<TrackingLinkPublicDetailsDto> {
    try {
      const res = await AXIOS_API.get(`/track-links/details/public`, {
        withCredentials: true,
        params: {
          token: trackLinkId,
        },
      });

      const body = res?.data;
      return body?.data ?? body;
    } catch (error) {
      console.error("Error getting tracking link details:", error);
      throw error;
    }
  }

  public async toggleTrackinLinkStatus({ trackLinkId, isActive }: { trackLinkId: string; isActive: boolean }) {
    try {
      const res = await AXIOS_API.patch(`/track-links/pos/${trackLinkId}`, {
        isActive,
      });

      const body = res?.data;
      return body?.data ?? body;
    } catch (error) {
      console.error("Error changing tracking link status:", error);
      throw error;
    }
  }

  public async deleteTrackingLink(id: string): Promise<boolean> {
    try {
      const url = `/track-links/${encodeURIComponent(id)}`;
      const res = await AXIOS_API.delete(url, { withCredentials: true });
      const body = res?.data;
      if (typeof body === "boolean") return body;
      return !!(body?.data ?? body?.success ?? false);
    } catch (error) {
      console.error("Error deleting tracking link:", error);
      throw error;
    }
  }

  public async updateTrackingLink(id: string, payload: FormData | Record<string, any>): Promise<any> {
    const url = `/track-links/${encodeURIComponent(id)}`;
    const res = await AXIOS_API.patch(url, payload, { withCredentials: true });
    const body = res?.data;
    return body?.data ?? body;
  }

  public async trackingLinkClicked(token: string, username?: string) {
    try {
      const res = await AXIOS_API.post(`/track-links-fans/click`, {
        token,
        username,
      });
      const body = res?.data;
      return body?.data ?? body;
    } catch (error) {
      console.error("Error clicking tracking link :", error);
      throw error;
    }
  }

  public getTable() {
    return JSON.parse(localStorage.getItem("visitedProfileWithTrackingLink") || "[]");
  }

  public saveTable(data: any) {
    localStorage.setItem("visitedProfileWithTrackingLink", JSON.stringify(data));
  }

  public async saveLocalStorageVisitedProfileByTrackLink() {
    try {
      const visitedProfile = this.getTable();

      if (visitedProfile?.length === 0) return;

      try {
        await AXIOS_API.post(`/track-links-fans/sync-local-clicks`, {
          visitedProfile,
        });

        localStorage.removeItem("visitedProfileWithTrackingLink");
      } catch (error) {
        console.error("Error saving visited profile:", error);
      }
    } catch (error) {
      console.error("Error saving visited profile:", error);
    }
  }
}

export const trackingLinksService = new TrackingLinksService();
